import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

const StepSchema = ({ formData, updateFormData, errors }) => {
  // Validate JSON syntax
  const jsonValidation = useMemo(() => {
    if (!formData.schema.trim()) {
      return { valid: false, message: 'JSON schema is required' };
    }
    try {
      JSON.parse(formData.schema);
      return { valid: true, message: 'Valid JSON' };
    } catch (e) {
      return { valid: false, message: `Invalid JSON: ${e.message}` };
    }
  }, [formData.schema]);

  return (
    <div className="wizard-step">
      <div className="step-intro">
        <h3>Define your JSON output structure</h3>
        <p>Provide the JSON schema that defines your expected output format.</p>
      </div>

      <div className="form-group">
        <label htmlFor="schema" className="form-label">
          JSON Schema
          <span className="label-required">*</span>
        </label>
        <textarea
          id="schema"
          value={formData.schema}
          onChange={(e) => updateFormData('schema', e.target.value)}
          placeholder={`{
  "type": "object",
  "properties": {
    "subject": { "type": "string" },
    "body": { "type": "string" },
    "tone": { "type": "string" }
  },
  "required": ["subject", "body"]
}`}
          className={`form-textarea code ${errors?.schema || !jsonValidation.valid ? 'form-error' : ''}`}
          rows="12"
          autoFocus
        />
        <div className="form-footer">
          <p className={`form-hint ${errors?.schema || !jsonValidation.valid ? 'error-text' : 'success-text'}`}>
            {errors?.schema || jsonValidation.message}
          </p>
          <span className={`validation-badge ${jsonValidation.valid ? 'valid' : 'invalid'}`}>
            {jsonValidation.valid ? '✓ Valid' : '✗ Invalid'}
          </span>
        </div>
      </div>
    </div>
  );
};

StepSchema.propTypes = {
  formData: PropTypes.shape({
    schema: PropTypes.string,
  }).isRequired,
  updateFormData: PropTypes.func.isRequired,
  errors: PropTypes.object,
};

StepSchema.defaultProps = {
  errors: {},
};

export default StepSchema;
